module.exports = __webpack_public_path__ + "img/Logo_rob1.93295545.png";